import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {
  FdAlertComponent,
  ModalDefinitions,
} from "src/app/shared/fd-form-components/fd-alert/fd-alert.component";
import { FdFieldConfigs } from "src/app/shared/fd-form-components/fd-form-components.module";
import { Messages } from "src/app/shared/messages/messages";
import { ErrorService } from "src/app/shared/service/error.service";
import { LoadingService } from "src/app/shared/service/loading.service";
import { FaqSaveModel } from "../../models/faqs.model";
import { FaqService } from "../../services/faq.service";

@Component({
    selector: "app-add-faq",
    templateUrl: "./add-faq.component.html",
    styleUrls: ["./add-faq.component.scss"],
    standalone: false
})
export class AddFaqComponent implements OnInit, OnDestroy {
  formGroup: UntypedFormGroup;
  fields: FdFieldConfigs;
  fieldsArray: FdFieldConfigs[] = new Array<FdFieldConfigs>();
  selectedInstitution: string;
  selectedServiceContract: string;
  selectedCategoryId: number;
  alive = true;

  ngOnDestroy() {
    this.alive = false;
  }

  constructor(
    private faqService: FaqService,
    private formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<AddFaqComponent>,
    private loadingService: LoadingService,
    private errorService: ErrorService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      institution: string;
      serviceContract: number;
    },
    private dialog: MatDialog
  ) {}

  changeSelectedInstitution(institution: string) {
    this.selectedInstitution = institution;
  }
  changeSelectedServiceContract(selectedServiceContract: string) {
    this.selectedServiceContract = selectedServiceContract;
  }
  changeSelectedCategory(selectedCategory: number) {
    this.selectedCategoryId = selectedCategory;
  }

  ngOnInit() {
    this.formGroup = this.createFormGroup();
    this.fields = this.createFields();
  }

  public isFormGroupValid(formGroup?: UntypedFormGroup): boolean {
    const formToBeValidated = !!formGroup ? formGroup : this.formGroup;
    if (formToBeValidated.invalid) {
      this.showErrorMessages(formToBeValidated);
      return false;
    }
    return true;
  }

  private showErrorMessages(formToBeValidated: UntypedFormGroup | UntypedFormArray) {
    let control;
    Object.keys(formToBeValidated.controls)
      .reverse()
      .forEach((field) => {
        control = formToBeValidated.get(field);
        if (control instanceof UntypedFormArray || control instanceof UntypedFormGroup) {
          this.showErrorMessages(control);
        } else {
          if (control && control.invalid) {
            control.markAsTouched();
          }
        }
      });
  }

  protected createFormGroup() {
    return this.formBuilder.group({
      institution: ["", Validators.required],
      serviceContract: ["", Validators.required],
      category: ["", Validators.required],
      url: [""],
      question: ["", Validators.required],
      answer: ["", Validators.required],
    });
  }

  get formControls(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  close() {
    this.dialogRef.close();
  }

  get hasServiceContract() {
    return (
      this.formControls.serviceContract &&
      this.formControls.serviceContract.value
    );
  }

  save() {
    let faq: FaqSaveModel = new FaqSaveModel();

    faq.institutionId = this.formControls.institution.value;
    faq.serviceContractId = this.formControls.serviceContract.value;
    faq.category = this.formControls.category.value;
    faq.url = this.formControls.url.value ? this.formControls.url.value : null;
    faq.question = this.formControls.question.value;
    faq.answer = this.formControls.answer.value;

    this.loadingService.show();

    this.faqService.saveFaq(faq).subscribe(
      (response) => {
        this.loadingService.hide();

        const successDialogRef = this.dialog.open(FdAlertComponent, {
          disableClose: true,
          width: ModalDefinitions.DEFAULT_MODAL_WIDTH,
          data: Messages.FAQ_SAVE_SUCCESS,
        });

        successDialogRef.afterClosed().subscribe((obs) => {
          this.dialogRef.close({ data: response });
        });
      },
      (error) => {
        this.loadingService.hide();
        this.errorService.handleXHRError(error, Messages.GENERAL_ERROR);
      }
    );
  }

  createFields(): FdFieldConfigs {
    return {
      institution: {
        label: "Nº Instituição",
        controlName: "institution",
        maskCharsReplace: /[. / -]/g,
        panelWidth: '320px',
        messages: {
          required: "Informe uma instituição",
          invalid: "Usuário inválido",
        },
      },
      serviceContract: {
        label: "Service Contract",
        controlName: "serviceContract",
        maskCharsReplace: /[. / -]/g,
        panelWidth: '320px',
        messages: {
          required: "Informe um service contract",
          invalid: "Usuário inválido",
        },
      },
      category: {
        label: "Categoria",
        controlName: "category",
        panelWidth: '320px',
        messages: {
          required: "Campo categoria obrigatório",
        },
      },
      url: {
        label: "URL",
        controlName: "url",
        maxLength: 150,
        messages: {},
      },
      question: {
        label: "Pergunta",
        controlName: "question",
        maxLength: 255,
        messages: {},
      },
      answer: {
        label: "Resposta",
        controlName: "answer",
        maxLength: 255,
        messages: {},
      },
    };
  }
}
